import React, { Component, Fragment } from 'react';
import { BreadCrumb } from '../../components/BreadCrumb';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { Loading, Card } from '../../components';
import "react-datepicker/dist/react-datepicker.css";
import { UserAccounts } from '../../components/UserAccounts';
import { UserService } from '../../services/UserService';
import { DataTableColumns } from '../../helpers/DataTableColumns';
import DataTable from 'react-data-table-component'
import "./AccountHistory.css";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { isArray } from 'util';


export class AccountHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            accountHistory: [],
            formData: {
                login: "",
                startDate: "",
                endDate: "",
            },
            userAccount: {
                active: null,
                list: [],
                info: {}
            }
        }

        this.changeAccount = this.changeAccount.bind(this);
        this.onDateChange = this.onDateChange.bind(this);

    }
    changeAccount(userAccount) {

        let startDate = localStorage.getItem("startDate"),
            endDate = localStorage.getItem("endDate");

        let tempFormData = this.state.formData;

        if (startDate) { tempFormData.startDate = new Date(startDate) }

        if (endDate) { tempFormData.endDate = new Date(endDate) }

        this.setState({
            userAccount: userAccount,
            formData: tempFormData
        });

    }
    onFilter(e) {

        if (this.isValidDate(this.state.formData.startDate) && this.isValidDate(this.state.formData.endDate)) {
            this.setState({ loading: true }, () => {
                let tempData = {
                    login: this.state.userAccount.active,
                    startDate: this.state.formData.startDate.toLocaleDateString() + " " + this.state.formData.startDate.toLocaleTimeString(),
                    endDate: this.state.formData.endDate.toLocaleDateString() + " " + this.state.formData.endDate.toLocaleTimeString()
                }
                UserService.Account.History(tempData).then((response) => {
                    if (response) {

                        this.setState({
                            accountHistory: response,
                            loading: false
                        });
                    }
                });
            });
        }
        e.preventDefault();
    }
    isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    }
    onDateChange(date) {

        let tempData = this.state.formData;

        if(date!==null && isArray(date)){
            tempData["startDate"] = date[0];
            tempData["endDate"] = date[1];         
        }
        else{
            tempData["startDate"] = "";
            tempData["endDate"] = "";
        }
        this.setState({
            formData: tempData
        });
        localStorage.setItem("startDate", tempData["startDate"]);
        localStorage.setItem("endDate", tempData["endDate"]);
    }

    render() {

        const data = {
            columns: DataTableColumns.accountHistory,
            rows: this.state.accountHistory
        };

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" />
                        <BreadCrumb Title="Account History" Name="Account History" />
                        <Card Title="Trade History" Description="History of transactions" className="tra-trade__history">
                            <div className="tra-filter__wrapper mb-3">
                                <div className="form-group mb-0">
                                    <label>Select Account</label>
                                    <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} />
                                </div>
                                <div className="form-group mb-0">

                                </div>
                                <div className="form-group mb-0">
                                    <label>Date Range</label>
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <DateRangePicker  className="date-range-picker form-control"
                                                    onChange={this.onDateChange}
                                                    value={[this.state.formData.startDate, this.state.formData.endDate]}
                                                    format={"dd.MM.yyyy"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-0">
                                    <label>&nbsp;</label>
                                    <button type="button" className="btn btn-dark bg-dark btn-block" onClick={e => this.onFilter(e)}>Filter History</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.accountHistory.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>No record!</strong> {Translate('You have no successful deposit transactions.')} </em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={data.columns}
                                            data={data.rows}
                                            defaultSortField="ticket"
                                            defaultSortAsc={false}
                                            pagination
                                            highlightOnHover />)}
                                </div>
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}